import _ from 'lodash'
import moment from 'moment'

export default subscriptionCtrl

/** @ngInject */
function subscriptionCtrl($scope, $state, $window, $rootScope, $uibModal, $timeout, $stateParams, ContractDraft,
                          Contract, MetterKind, MailAdresses, DeviceChecker, ReferencesService, User, Contact, MobilePhone, CommonRegex,
                          contractDraft, DataAccessVariables, ContactTelephone, featuresService, LandscapeQuestions, ErrorCatcher, PrmUtilsService) {
    const DEFAULT_PROMO_OK_MSG = 'Code promotionnel valide.'
    const SUBSCRIPTION_TYPE = {
        emmenagement: 'emmenagement',
        changementFournisseur: 'changementfournisseur',
        subscriptionEmmenagement: 'subscriptionEmmenagement',
        subscriptionChangementFournisseur: 'subscriptionChangementFournisseur',
    }
    const PDL_SUBSCRIPTION_TYPE = {
        CDF: 'CDF',             // changement de fournisseur
        CDF_INTER: 'CDF_INTER', // changement de fournisseur avec intervention
        MES: 'MES',             // mise en service sans intervention
        MES_INTER: 'MES_INTER', // mise en service intervention
        FIRST_MES: 'FIRST_MES', // premiere mise en service
    }
    const commonMESTarifs = function (meter_kind) {
        const MESPrices = [
            { label: 'Normale', id: 'NORMAL', delay: 5, price: '21,23' },
            { label: 'Express', id: 'EXPRESS', delay: 2, price: '58,57' },
        ]
        if (PrmUtilsService.isLinky(meter_kind)) {
            MESPrices.push({ label: 'Jour même', id: 'TODAY', delay: 1, price: '72,90' })
        } else {
            MESPrices.push({ label: 'Jour même', id: 'TODAY', delay: 1, price: '150,39' })
        }
        return MESPrices
    }
    const MESWithoutInterTariff = function () {
        return [{ label: 'Normale', id: 'NORMAL', delay: 5, price: '21,23' }]
    }
    const firstMESTariff = function (meter_kind) {
        const MESPrices = [
            { label: 'Normale', id: 'NORMAL', delay: 10, price: '49,31' },
            { label: 'Express', id: 'EXPRESS', delay: 5, price: '86.65' },
        ]
        if (PrmUtilsService.isLinky(meter_kind)) {
            MESPrices.push({ label: 'Jour même', id: 'TODAY', delay: 1, price: '100,98' })
        } else {
            MESPrices.push({ label: 'Jour même', id: 'TODAY', delay: 1, price: '178,47' })
        }
        return MESPrices
    }
    const MESTariffs = {
        CDF: commonMESTarifs,
        CDF_INTER: commonMESTarifs,
        MES: MESWithoutInterTariff,
        MES_INTER: commonMESTarifs,
        FIRST_MES: firstMESTariff,
    }

    $scope.subscriptionType = SUBSCRIPTION_TYPE.changementFournisseur

    const $controllerScope = $scope
    $scope.$stateParams = $stateParams
    $scope.nameRegex = CommonRegex.fullname
    $scope.phoneRegex = MobilePhone.phoneRegex.all
    $scope.isPartnerSubscription = $state.$current.data.isPartnerSubscription
    $scope.partnerOffer = $state.$current.data.partnerOffer
    $scope.currentInput = null
    $scope.contractDraft = {}
    $scope.reading = {}
    $scope.pdlResponse = null
    $scope.showSpinner = false
    $scope.isUpdating = false
    $scope.isPRMEligible = false
    $scope.displaySubscriptionHelp = false
    $scope.MetterKind = MetterKind
    $scope.MailAdresses = MailAdresses
    $scope.sponsorValidation = {
        errorMessage: null,
        isValid: true,
        isChecking: false,
    }
    $scope.promoValidation = {
        errorMessage: null,
        isValid: true,
        isChecking: false,
    }
    $scope.isMobile = DeviceChecker.isMobile
    $scope.showSponsor = !contractDraft.already_has_sponsor && (localStorage.sponsorId !== undefined) && (localStorage.sponsorId !== '')
    $scope.birth_date_day = moment(contractDraft.birth_date).isValid() ? moment(contractDraft.birth_date).format('DD') : undefined
    $scope.birth_date_month = moment(contractDraft.birth_date).isValid() ? moment(contractDraft.birth_date).format('MM') : undefined
    $scope.birth_date_year = moment(contractDraft.birth_date).isValid() ? moment(contractDraft.birth_date).format('YYYY') : undefined
    $scope.phone = contractDraft.phone
    $scope.contactTelephone = ContactTelephone.anonymous
    $scope.allContactTelephone = ContactTelephone
    $scope.enableVerify = true

    // MES + FIRST_MES
    $scope.calendarIds = undefined
    $scope.powers = undefined
    let availablePowers

    const setContractDraft = (contractDraft) => {
        $scope.contractDraft = {
            id: contractDraft.id,
            id_prm: contractDraft.id_prm,
            civ: contractDraft.civ,
            sn: contractDraft.sn,
            givenname: contractDraft.givenname,
            mail: contractDraft.mail,
            accept_contacts: contractDraft.accept_contacts,
            heating: contractDraft.heating,
            birth_date: moment(contractDraft.birth_date).isValid() ? moment(contractDraft.birth_date).format('YYYY-MM-DD') : undefined,
            sponsor_id: contractDraft.sponsor_id || localStorage.sponsorId,
            id_ref_promo: contractDraft.id_ref_promo || localStorage.promoId,
            is_a_move: SUBSCRIPTION_TYPE.emmenagement === $scope.subscriptionType,
            choosen_mes_type: contractDraft.choosen_mes_type,
            consuel: contractDraft.consuel,
            ready_to_checkout: contractDraft.ready_to_checkout,
            sleek_timetable: contractDraft.sleek_timetable,
            primary_residence: contractDraft.primary_residence,
            phone: contractDraft.phone,
            utm_source: contractDraft.utm_source,
            utm_medium: contractDraft.utm_medium,
            utm_campaign: contractDraft.utm_campaign,
            estimated_v: contractDraft.estimated_v,
            nextBillableDate: contractDraft.nextBillableDate,
            switchReadings: {
                base: __guard__((contractDraft.switchReadings.filter((reading) => reading.dial === 'Base'))[0], (x) => x.value),
                hp: __guard__((contractDraft.switchReadings.filter((reading) => reading.dial === 'Heures Pleines'))[0], (x1) => x1.value),
                hc: __guard__((contractDraft.switchReadings.filter((reading) => reading.dial === 'Heures Creuses'))[0], (x2) => x2.value),
            },
        }
    }

    setContractDraft(contractDraft)

    $scope.cards = [{
        id: 1,
        image: 'img-changer-fournisseur',
        description: 'Je change de fournisseur pour mon logement actuel',
        type: SUBSCRIPTION_TYPE.changementFournisseur,
    }, {
        id: 2,
        image: 'img-contrat-nouveau-logement',
        description: 'J’ouvre un contrat pour mon nouveau logement',
        type: SUBSCRIPTION_TYPE.emmenagement,
    }]
    $scope.items = {}
    $scope.items[SUBSCRIPTION_TYPE.changementFournisseur] = {
        title: 'Changer de fournisseur d’énergie, c’est simple et gratuit !',
        description: 'Une fois votre commande terminée, nous nous occuperons de résilier votre contrat chez votre ancien fournisseur.',
    }
    $scope.items[SUBSCRIPTION_TYPE.emmenagement] = {
        title: 'Merci d’avoir choisi Plüm énergie !',
        description: 'Nous allons créer ensemble le dossier pour ouvrir votre contrat d’électricité.',
    }

    $scope.process = [
        {
            name: 'situation',
            isActive: true,
            isUpdating: false,
            error: false,
            errorMessage: undefined,
            changeType(type) {
                $scope.subscriptionType = type
            },
            getSituationClass(type) {
                return $scope.subscriptionType === type ? 'active' : 'inactive'
            },
            validate() {
                $scope.contractDraft.is_a_move = SUBSCRIPTION_TYPE.emmenagement === $scope.subscriptionType
                $scope.goToNextProcess(this)
            },
        },
        {
            name: 'identity',
            isActive: false,
            isUpdating: false,
            error: false,
            errorMessage: undefined,
            initSponsorFee() {
                return DataAccessVariables.get({ variables: 'SPONSOR_FEE,SPONSORED_FEE' }).$promise
                .then((variables) => {
                    if (variables.SPONSOR_FEE === variables.SPONSORED_FEE) {
                        $scope.sponsorOkMessage = `Une fois votre commande terminée et votre compteur activé, vous et votre parrain serez crédités de ${
                variables.SPONSORED_FEE}€.`
                    }
                    $scope.sponsorOkMessage = `Une fois votre commande terminée et votre compteur activé, vous et votre parrain serez crédités respectivement de ${
              variables.SPONSOR_FEE}€ et ${variables.SPONSORED_FEE}€.`
                })
                .catch((error) => {
                    $scope.sponsorOkMessage = 'Vous et votre parrain serez crédités une fois votre commande terminée et votre compteur activé.'
                    return ErrorCatcher.catchError(error)
                })
            },
            initAvailablePower() {
                return ReferencesService.getRefPromise('ot-ps')
                .then((result) => {
                    availablePowers = result.toJSON()
                    $scope.calendarIds = [{
                        id: null,
                        label: '-- Choisissez --',
                    }].concat(_.map(availablePowers, (v, k) => ({ id: k, label: v.label })))
                })
                .catch(ErrorCatcher.catchError)
            },
            checkSponsor() {
                if (_.get($scope, 'contractDraft.sponsor_id.length') === 9) {
                    $scope.sponsorValidation = { errorMessage: null, isValid: false, isChecking: true }
                    return ContractDraft.checkSponsor({ sponsor_id: $scope.contractDraft.sponsor_id }).$promise
                    .then(() => {
                        $scope.sponsorValidation = { errorMessage: null, isValid: true, isChecking: false }
                    })
                    .catch((error) => {
                        const DEFAULT_ERROR_MSG = 'Une erreur est survenue, merci de vérifier le numéro client de votre parrain'
                        const errorMessage = error.status === 400 ? error.data.message : DEFAULT_ERROR_MSG
                        $scope.sponsorValidation = { errorMessage, isValid: false, isChecking: false }
                        return ErrorCatcher.catchError(error)
                    })
                } else if (_.isEmpty($scope.contractDraft.sponsor_id) || ($scope.contractDraft.sponsor_id.length === 0)) {
                    $scope.sponsorValidation = { errorMessage: null, isValid: true, isChecking: false }
                } else {
                    $scope.sponsorValidation = {
                        errorMessage: 'Format : CLxxxxxxx (CL et 7 caractères)',
                        isValid: false,
                        isChecking: false,
                    }
                }
            },
            checkPromo(softCheck) {
                if (_.get($scope, 'contractDraft.id_ref_promo.length', 0) > 0) {
                    $scope.promoValidation = { message: null, errorMessage: null, isValid: false, isChecking: true }
                    return ContractDraft.checkPromo({ promo: $scope.contractDraft.id_ref_promo, soft: softCheck }).$promise
                    .then((result) => {
                        const message = result.label_fr || DEFAULT_PROMO_OK_MSG
                        return $scope.promoValidation = { message, errorMessage: null, isValid: true, isChecking: false }
                    })
                    .catch((error) => {
                        const DEFAULT_ERROR_MSG = 'Une erreur est survenue, merci de vérifier votre code promotionnel'
                        const errorMessage = error.status === 400 ? error.data.message : DEFAULT_ERROR_MSG
                        $scope.promoValidation = { message: null, errorMessage, isValid: false, isChecking: false }
                        return ErrorCatcher.catchError(error)
                    })
                }
                $scope.promoValidation = { message: null, errorMessage: null, isValid: true, isChecking: false }
            },
            isSponsorValid() {
                return $scope.sponsorValidation.isValid
            },
            isPromoValid() {
                return $scope.promoValidation.isValid
            },
            updateBirthDate() {
                const birthdate = moment({ years: $scope.birth_date_year, months: $scope.birth_date_month - 1, day: $scope.birth_date_day })
                $scope.contractDraft.birth_date = birthdate.isValid() ? birthdate.format('YYYY-MM-DD') : undefined
                $scope.birthDateError = _.isEmpty($scope.birth_date_year) || _.isEmpty($scope.birth_date_month) || _.isEmpty($scope.birth_date_day) || !birthdate.isValid()
            },
            updateMobilePhone() {
                $scope.contractDraft.phone = !_.isEmpty($scope.phone) ? MobilePhone.formatPhoneToPlus33($scope.phone) : undefined
            },
        },
        {
            name: 'pdl',
            isActive: false,
            isUpdating: false,
            isVerifying: false,
            error: false,
            errorMessage: undefined,
            authorizationToVerify: false,
            onStateActive() {
                const DISPLAY_HELP_DELAY = 15000
                $timeout(() => {
                    if ($scope.pdlResponse === null) {
                        $scope.displaySubscriptionHelp = true
                    }
                }, DISPLAY_HELP_DELAY)
            },
            verify(currentStep) {
                const updateMESTariff = function (pdlResponse) {
                    $scope.MESTariff = MESTariffs[pdlResponse.subscriptionType](pdlResponse.metter.kind)
                    $scope.contractDraft.choosen_mes_type = $scope.MESTariff[0].id
                    $scope.choosenMESTariff = $scope.MESTariff[0]
                }

                const openPDLDisabledModal = () => {
                    $uibModal.open({
                        animation: true,
                        size: 'lg',
                        template: require('./modal/pdlDisabledModal.jade')(),
                        controller($scope, $uibModalInstance, ContactTelephone) {
                            $scope.close = $uibModalInstance.dismiss
                            $scope.contactTelephone = ContactTelephone.anonymous
                            $scope.resetPDL = function () {
                                $scope.close()
                                $controllerScope.isPRMEligible = false
                                $controllerScope.pdlResponse = null
                            }
                            $scope.confirmToEmmenagement = function () {
                                $scope.close()
                                if (!$controllerScope.isPartnerSubscription) {
                                    $state.transitionTo('subscriptionEmmenagement', { notify: false })
                                }
                                $controllerScope.contractDraft.is_a_move = true
                                $controllerScope.subscriptionType = SUBSCRIPTION_TYPE.emmenagement
                            }
                        },
                    })
                }

                const openSubscriptionSwitchStandardOffer = () => {
                    $uibModal.open({
                        animation: true,
                        size: 'lg',
                        component: 'subscriptionSwitchStandardOffer',
                    }).result.then((result) => {
                        if (result.switchToStandardOffer) {
                            ContractDraft.modifyDraftOffer({ provider_offer: 'STANDARD' }, {}).$promise.then(() => {
                                $state.go('subscription')
                            }).catch((error) => {
                                if (!error.message === 'transition prevented') {
                                    ErrorCatcher.catchErrorWithoutRedirect(error)
                                }
                            })
                        }
                    })
                }

                $scope.isPRMEligible = false
                $scope.pdlResponse = null
                $scope.contractDraft.choosen_max_power = null
                $scope.contractDraft.choosen_id_p_calendar = null
                const currentStepIndex = $scope.getCurrentProcessIndex()
                $scope.process[currentStepIndex].error = false
                const formatErrorMessage = 'Le numéro de point de livraison que vous avez renseigné ne semble pas correct. Vérifiez bien les 14 chiffres sur votre facture d’électricité.'
                if ($scope.contractDraft.id_prm) {
                    if (!currentStep.authorizationToVerify) {
                        $scope.enableVerify = false
                        return
                    }
                    $scope.enableVerify = true
                    currentStep.isVerifying = true
                    return ContractDraft.verify({
                        id: $scope.contractDraft.id_prm,
                        id_contract: $scope.contractDraft.id,
                        consent: true,
                    }).$promise
                    .then((PDLResponse) => {
                        if (PDLResponse.eligible) {
                            $scope.isPRMEligible = true
                            $scope.pdlResponse = PDLResponse
                            updateMESTariff(PDLResponse)
                            $scope.updateChoosenCalendarId()
                            if (($scope.subscriptionType === SUBSCRIPTION_TYPE.changementFournisseur) && $scope.pdlResponse.terminated) {
                                return openPDLDisabledModal()
                            }
                            if (['offreRentree2018', 'offreAutomne2018'].indexOf($scope.partnerOffer) > -1 && _.get($scope.pdlResponse, 'plan.id_p_calendar') === 'BASE') {
                                return openSubscriptionSwitchStandardOffer()
                            }
                        } else {
                            $scope.process[currentStepIndex].error = true
                            $scope.process[currentStepIndex].errorMessage = PDLResponse.message
                        }
                    })
                    .catch((error) => {
                        const errorMessage = (error.status !== 400) ? undefined : formatErrorMessage
                        $scope.process[currentStepIndex].error = true
                        $scope.process[currentStepIndex].errorMessage = errorMessage
                        $scope.sendEnedisDownMessage()
                        return ErrorCatcher.catchError(error)
                    })
                    .finally(() => {
                        currentStep.isVerifying = false
                    })
                }
                $scope.process[currentStepIndex].error = true
                $scope.process[currentStepIndex].errorMessage = formatErrorMessage
            },
            validate() {
                const currentStep = this;
                ({ contractDraft } = $scope)
                const updateCurrentStep = () => $scope.update(currentStep)
                const openAreYouSureModal = () =>
                    $uibModal.open({
                        animation: true,
                        size: 'lg',
                        template: require('./modal/areYouSureModal.jade')(),
                        controller($scope, $uibModalInstance, ContactTelephone) {
                            $scope.close = $uibModalInstance.dismiss
                            $scope.contactTelephone = ContactTelephone.anonymous
                            $scope.confirm = function () {
                                $scope.close()
                                return updateCurrentStep()
                            }
                        },
                    })
                if (($scope.subscriptionType === SUBSCRIPTION_TYPE.emmenagement) && !$scope.pdlResponse.terminated) {
                    return openAreYouSureModal()
                }
                return updateCurrentStep()
            },
            canGoOnPRM() {
                const isMaxPower = Boolean($scope.pdlResponse.power.max || $scope.contractDraft.choosen_max_power)
                const hasPlan = Boolean($scope.pdlResponse.plan || $scope.contractDraft.choosen_id_p_calendar)
                if ($scope.pdlResponse.subscriptionType === 'FIRST_MES') {
                    const isConsuelDefinedOnFirstMES = _.isBoolean($scope.contractDraft.consuel)
                    return isMaxPower && hasPlan && isConsuelDefinedOnFirstMES
                }
                return isMaxPower && hasPlan
            },

            updateChoosenMESTariff() {
                $scope.choosenMESTariff = _.find($scope.MESTariff, { id: $scope.contractDraft.choosen_mes_type })
            },
            openContactFormUnknownPDL() {
                return $uibModal.open({
                    animation: true,
                    size: 'lg',
                    template: require('./modal/subscriptionContactUnknownPRM.jade')(),
                    controller: 'subscriptionContactUnknownPRMCtrl',
                    resolve: {
                        email() {
                            return $scope.contractDraft.mail
                        },
                        phone() {
                            return $scope.contractDraft.phone
                        },
                    },
                })
            },
        },
        {
            name: 'report',
            isActive: false,
            isUpdating: false,
            error: false,
            errorMessage: undefined,
            overrideNotTerminatedPDL: false,
            bypassReadings(currentStep) {
                $uibModal.open({
                    animation: true,
                    component: 'bypassReadingsAlert',
                    resolve: {},
                }).result.then((result) => {
                    if (result.bypassReadings) {
                        $scope.goToNextProcess(currentStep)
                    }
                })
            },
            report(currentStep, reading) {
                $scope.isUpdating = true
                currentStep.isUpdating = true
                const currentStepIndex = $scope.getCurrentProcessIndex()
                return ContractDraft.report({}, reading).$promise
                .then((response) => {
                    $scope.process[currentStepIndex].error = false
                    return $scope.goToNextProcess(currentStep)
                })
                .catch((error) => {
                    $scope.process[currentStepIndex].error = true
                    $scope.process[currentStepIndex].errorMessage = 'Nous n’avons pas pu enregistrer votre relève. Si le problème persiste, vous pouvez passer cette étape.'
                    $scope.isUpdating = false
                    currentStep.isUpdating = false
                    return ErrorCatcher.catchError(error)
                })
            },
            isLinky() {
                return PrmUtilsService.isLinky(_.get($scope, 'pdlResponse.metter.kind'))
            },
            isFirstMES() {
                const isFirstMes = _.get($scope, 'pdlResponse.subscriptionType') === PDL_SUBSCRIPTION_TYPE.FIRST_MES
                const hasNotPlan = !_.get($scope, 'pdlResponse.plan')
                return isFirstMes || hasNotPlan
            },
        },
        {
            name: 'heating',
            isActive: false,
            isUpdating: false,
            error: false,
            errorMessage: undefined,
        },
        {
            name: 'timetable',
            isActive: false,
            isUpdating: false,
        },
        {
            name: 'pay',
            isActive: false,
            isUpdating: false,
            error: false,
            errorMessage: undefined,
            goToPayment(currentStep) {
                $scope.isUpdating = true
                currentStep.isUpdating = true
                $scope.contractDraft.ready_to_checkout = true
                ContractDraft.update({}, { ready_to_checkout: true }).$promise
                .then(() => ContractDraft.getPaymentIframe({ id: $scope.contractDraft.id }).$promise)
                .then((response) => {
                    window.location = response.redirectUrl
                })
                .catch((error) => {
                    $scope.isUpdating = false
                    currentStep.isUpdating = false
                    ErrorCatcher.catchError(error)
                })
            },
            goToShowroomCreateAccount(currentStep, newUser) {
                $scope.isUpdating = true
                currentStep.isUpdating = true
                $scope.contractDraft.ready_to_checkout = true
                let contractDraftPayload = { ready_to_checkout: true }
                if ($scope.partnerOffer === 'offrePrintemps2018') {
                    contractDraftPayload = { ready_to_checkout: true, id_ref_promo: _.defaultTo($state.params.id_ref_promo, 'PRINTEMPS_2018_SELECTRA') }
                }

                ContractDraft.update({}, contractDraftPayload).$promise
                .then(() => User.signUp(_.assign({}, newUser, {
                    civ: $scope.contractDraft.civ,
                    givenName: $scope.contractDraft.givenname,
                    sn: $scope.contractDraft.sn,
                    email: $scope.contractDraft.mail,
                    phone: $scope.contractDraft.phone,
                    birth_date: $scope.contractDraft.birth_date,
                    utm_source: localStorage.utm_source,
                    utm_medium: localStorage.utm_medium,
                    utm_campaign: localStorage.utm_campaign,
                })).$promise)
                .then(() => {
                    localStorage.removeItem('utm_source')
                    localStorage.removeItem('utm_medium')
                    localStorage.removeItem('utm_campaign')
                    return $state.go('subscriptionEnd', { email: $scope.contractDraft.mail })
                })
                .catch((error) => {
                    $scope.isUpdating = false
                    currentStep.isUpdating = false
                    ErrorCatcher.catchError(error)
                    if (error.status === 409) {
                        $state.go('subscriptionSummary')
                    } else if (!_.isEmpty(_.get(error, 'data.message'))) {
                        currentStep.error = { isError: true, code: 'SERVICE_MSG', message: error.data.message }
                    } else {
                        currentStep.error = { isError: true, code: 'DEFAULT_MSG' }
                    }
                })
            },
        },
        {
            name: 'landscape',
            isActive: false,
            isUpdating: false,
            error: false,
            errorMessage: undefined,
        },
    ]

    $scope.updateChoosenCalendarId = function () {
        $scope.powers = [{ id: null, label: '-- Choisissez --' }]
        const calendar = availablePowers[_.get($scope, 'pdlResponse.plan.id_p_calendar')] || availablePowers[$scope.contractDraft.choosen_id_p_calendar]
        if (calendar) {
            $scope.powers = $scope.powers.concat(calendar.availablePowers.map((p) => ({ id: p, label: `${p}kVA` })))
        }
    }

    $scope.isPromoMessageDefault = () => $scope.promoValidation.message === DEFAULT_PROMO_OK_MSG

    $scope.focus = (input) => {
        $scope.currentInput = input
    }

    $scope.active = (activeStep) => {
        if (activeStep === 'pdl') {
            $scope.process[2].onStateActive()
        }
        Array.from($scope.process).forEach((step) => {
            step.isActive = step.name === activeStep
        })
    }


    $scope.getCurrentProcessIndex = function (forceIndex) {
        if (forceIndex) {
            return forceIndex
        }
        let currentStepIndex = null
        let index = 0
        while (index < Math.max($scope.process.length, 0)) {
            if ($scope.process[index].isActive) {
                currentStepIndex = index
            }
            index += 1
        }
        return currentStepIndex
    }

    $scope.goToNextProcess = function (currentStep, forceIndex) {
        $scope.isUpdating = true
        currentStep.isUpdating = true
        const currentStepIndex = $scope.getCurrentProcessIndex(forceIndex)
        if ((currentStepIndex !== undefined) && (currentStepIndex !== ($scope.process.length - 1))) {
            if ($scope.process[currentStepIndex].name === 'report') {
                const subscriptionTypeForRequiredLandscape = [
                    PDL_SUBSCRIPTION_TYPE.FIRST_MES,
                    PDL_SUBSCRIPTION_TYPE.MES,
                    PDL_SUBSCRIPTION_TYPE.MES_INTER,
                ]
                if (subscriptionTypeForRequiredLandscape.indexOf(_.get($scope, 'pdlResponse.subscriptionType')) > -1) {
                    $scope.landscapeRequired = true
                    $scope.getLandscapeQuestions().result.then(() => {
                        $timeout(() => {
                            $scope.isUpdating = false
                            currentStep.isUpdating = false
                        })
                    }).catch(() => {
                        $scope.isUpdating = false
                        currentStep.isUpdating = false
                    })
                } else {
                    featuresService.getFeatures((features) => {
                        if (features.landscapeSubscription) {
                            $scope.showSpinner = true
                            $scope.checkLandscapeRequired((response) => {
                                if ($scope.landscapeRequired) {
                                    $scope.getLandscapeQuestions().result.then(() => {
                                        $timeout(() => {
                                            $scope.isUpdating = false
                                            currentStep.isUpdating = false
                                        })
                                    }).catch(() => {
                                        $scope.isUpdating = false
                                        currentStep.isUpdating = false
                                    })
                                } else {
                                    $scope.active($scope.process[4].name)
                                    $scope.isUpdating = false
                                    currentStep.isUpdating = false
                                }
                            })
                        } else {
                            $scope.active($scope.process[currentStepIndex + 1].name)
                            $scope.isUpdating = false
                            currentStep.isUpdating = false
                        }
                    })
                }
            } else if ($scope.process[currentStepIndex].name === 'heating' || $scope.process[currentStepIndex].name === 'landscape') {
                ContractDraft.get({ create: true, withRelated: 'nextBillableDate' }).$promise
                .then((data) => {
                    setContractDraft(data)
                    $scope.active($scope.process[currentStepIndex + 1].name)
                    $scope.isUpdating = false
                    currentStep.isUpdating = false
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                })
            } else {
                $scope.active($scope.process[currentStepIndex + 1].name)
                $scope.isUpdating = false
                currentStep.isUpdating = false
            }
        } else {
            $scope.isUpdating = false
            currentStep.isUpdating = false
        }
    }

    $scope.getLandscapeQuestions = function () {
        const uibModalOptions = {
            size: 'xs',
            template: require('./modal/landscapeConfirmModal.jade')(),
            backdrop: 'TRUE',
            controller: 'landscapeConfirmModalCtrl',
        }

        const modal = $uibModal.open(uibModalOptions)
        modal.result.then(() => $scope.openLandscapeModal())
        return modal
    }

    $scope.openLandscapeModal = function (edit) {
        $scope.doingLandscape = true
        $scope.active($scope.process[7].name)
        return LandscapeQuestions.search({
            category: 'c-est-parti',
            id_contract: $scope.contractDraft.id,
            draft: true,
        }).$promise
        .then((landscapeQuestions) => {
            let isNew = false
            if (landscapeQuestions && (landscapeQuestions.length === 1)) {
                if ((landscapeQuestions[0][0].answer === undefined) || (landscapeQuestions[0][0].answer === '') || (landscapeQuestions[0][0].answer === false)) {
                    isNew = true
                }
            }

            const uiModalOptions = {
                animation: true,
                size: 'xlg',
                template: require('./modal/landscapeModal.jade')(),
                backdrop: 'static',
                resolve: {
                    landscapeQuestions() {
                        return landscapeQuestions
                    },
                    idContract() {
                        $scope.showSpinner = true
                        return contractDraft.id
                    },
                    isEdition() {
                        return { edition: edit, new: isNew }
                    },
                },

                controller: 'landscapeModalCtrl',
            }

            if (landscapeQuestions[0][0] && (edit !== true)) {
                if (landscapeQuestions[0][0].answer && (landscapeQuestions[0][0].answer !== '')) {
                    uiModalOptions.size = 'hidden'
                    uiModalOptions.backdrop = false
                }

                const lastBlock = landscapeQuestions[landscapeQuestions.length - 1]
                if (lastBlock[Object.keys(lastBlock).length - 1] && lastBlock[Object.keys(lastBlock).length - 1].last) {
                    $scope.landscapeDone = true
                }
            }

            const landscapeModal = $uibModal.open(uiModalOptions)
            landscapeModal.result.then((result) => {
                if (result && result.canvas) {
                    const landscapeCanvasSub = document.getElementById('landscape-canvas-sub')
                    while (landscapeCanvasSub.firstChild) {
                        landscapeCanvasSub.removeChild(landscapeCanvasSub.firstChild)
                    }
                    landscapeCanvasSub.appendChild(result.canvas)
                }
                if (result.heating) {
                    $scope.contractDraft.heating = result.heating
                }
                if (_.isBoolean(result.primary_residence)) {
                    $scope.contractDraft.primary_residence = result.primary_residence
                }
                if (result.landscapeDone) {
                    $scope.landscapeDone = true
                }
                $scope.landscapeLoaded = true
            })
            return landscapeModal.rendered
            .then(() => $rootScope.$broadcast('landscapeModalReady', {}))
            .catch(ErrorCatcher.catchError)
        })
    }

    $scope.editLandscape = () => $scope.openLandscapeModal(true)

    $scope.checkLandscapeRequired = (callback) =>
    ContractDraft.checkLandscapeRequired({
        id_contract: $scope.contractDraft.id,
    }).$promise
      .then((result) => {
          $scope.landscapeRequired = ($scope.contractDraft.is_a_move || result.required)
          return callback(result)
      })
      .catch(ErrorCatcher.catchError)

    $scope.trackEvent = function (eventName) {
        const campainId = localStorage.id_campaign || 'default'
    // GA EVENT
        $window.ga('send', {
            hitType: 'event',
            eventCategory: campainId,
            eventAction: `update - Souscription - ${eventName}`,
            eventLabel: `${campainId} Campaign Subscription Step`,
            transport: 'beacon',
        })

        return true
    }

    $scope.update = function (currentStep) {
        $scope.isUpdating = true
        currentStep.isUpdating = true

        if (($scope.contractDraft.sponsor_id !== null) && ($scope.contractDraft.sponsor_id !== undefined) && ($scope.contractDraft.sponsor_id.length === 0)) {
            $scope.contractDraft.sponsor_id = null
        }
        if (($scope.contractDraft.id_ref_promo !== null) && ($scope.contractDraft.id_ref_promo !== undefined) && ($scope.contractDraft.id_ref_promo.length === 0)) {
            $scope.contractDraft.id_ref_promo = null
        }
        return ContractDraft.update({}, $scope.contractDraft).$promise
        .then((response) => {
        //     when the draft is updated, we can flush the sponsorId from the localStorage
            localStorage.removeItem('sponsorId')
            localStorage.removeItem('promoId')
            return $scope.goToNextProcess(currentStep)
        })
        .catch((error) => {
            $scope.isUpdating = false
            currentStep.isUpdating = false
            return ErrorCatcher.catchError(error)
        })
    }

    $scope.updateContractDraft = function (value) {
        $scope.contractDraft = _.assign({}, $scope.contractDraft, value)
        return ContractDraft.update({}, value).$promise
        .catch((error) => ErrorCatcher.catchError(error))
    }

    $scope.getPowerMax = function () {
        return _.defaultTo(_.get($scope.pdlResponse, 'power.max'), $scope.contractDraft.choosen_max_power)
    }

    $scope.sendEnedisDownMessage = function () {
        const jiraIssue = {
            summary: `${$scope.contractDraft.civ} ${$scope.contractDraft.sn} ${$scope.contractDraft.givenname} : Rappel finalisation de commande`,
            description: `${$scope.contractDraft.civ} ${$scope.contractDraft.sn} ${$scope.contractDraft.givenname} n’a pas pu terminer sa commande en raison d’une indisponibilité Enedis.`,
            type: 'Task',
            epicLink: 'SN2-934',
            idContract: $scope.contractDraft.id,
            idPrm: $scope.contractDraft.id_prm,
            enrichSummary: false,
        }
        if (localStorage.prm !== $scope.contractDraft.id_prm) {
            localStorage.prm = $scope.contractDraft.id_prm
            ContractDraft.createJiraIssue({ idProject: 'support' }, jiraIssue).$promise.catch(ErrorCatcher.catchError)
        }
    }

    $scope.$watch('contractDraft.id_prm', () => {
        $scope.isPRMEligible = false
        $scope.pdlResponse = null
    })

    $scope.openFindPdlHelperModal = () => {
        $uibModal.open({
            animation: true,
            size: 'lg',
            component: 'findPdlHelper',
            resolve: {
                partnerOffer: () => $scope.partnerOffer,
            },
        })
    }

    const activate = function () {
        // GA EVENT
        // initial GA event Start subscription
        const campainId = localStorage.id_campaign || 'default'
        $window.ga('send', {
            hitType: 'event',
            eventCategory: campainId,
            eventAction: `page - Souscription - ${$scope.subscriptionType}`,
            eventLabel: `${campainId} Campaign Subscription Step`,
            transport: 'beacon',
        })

        $scope.process[1].initSponsorFee()
        $scope.process[1].initAvailablePower()
        $scope.process[1].updateBirthDate()
        if (!$scope.isPartnerSubscription) {
            $scope.process[1].checkSponsor()
            $scope.process[1].checkPromo(true)
        }

        // Disable zendesk btn
        if (window.zE) {
            window.zE(() => {
                window.zE.hide()
            })
        }
    }

    activate()
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/states/subscription/subscription.js